// Central timezone helpers — the business operates on America/Chicago (CDT/CST).
// All timestamps are stored in UTC; these utilities render them in Chicago time
// regardless of the viewer's device timezone.

export const CHICAGO_TZ = "America/Chicago";

const coerce = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const fmtChicago = (value, options = {}) => {
  const d = coerce(value);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-US", { timeZone: CHICAGO_TZ, ...options }).format(d);
};

// Presets used across the app
// Date format shows weekday short name (e.g. "Tue, 05/27/2026") so admins/drivers
// can see which day of the week a trip falls on without doing math.
export const fmtChicagoDate = (value) =>
  fmtChicago(value, { weekday: "short", month: "2-digit", day: "2-digit", year: "numeric" });

// Bare numeric date with no weekday — used in screens with little space
export const fmtChicagoDateNumeric = (value) =>
  fmtChicago(value, { month: "2-digit", day: "2-digit", year: "numeric" });

export const fmtChicagoTime = (value) =>
  fmtChicago(value, { hour: "2-digit", minute: "2-digit" });

export const fmtChicagoDateTime = (value) =>
  fmtChicago(value, {
    month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit",
  });

export const fmtChicagoWeekday = (value) =>
  fmtChicago(value, { weekday: "short" });

export const fmtChicagoMonthDay = (value) =>
  fmtChicago(value, { month: "short", day: "numeric" });

export const fmtChicagoLongDate = (value) =>
  fmtChicago(value, { weekday: "long", month: "long", day: "numeric", year: "numeric" });

export const fmtChicagoMonthYear = (value) =>
  fmtChicago(value, { month: "long", year: "numeric" });
